/** FROZEN (W0-contracts). Calendar owns event/reminder/recurrence behavior. */
import { lazy, Suspense, type ReactElement } from 'react';
import type { Id } from '@/model';
import { Spinner } from '@/ui';
import { useTranslation } from 'react-i18next';
const Host = lazy(() => import('./CalendarSheetHost'));

export interface ItemCalendarSheetProps {
  itemId: Id;
  mode: 'edit' | 'invitations' | 'reminders';
  onClose(): void;
  onSaved?(): void;
}
/** Reminders support ordinary tasks too. Edit is event-only; unknown/unsupported timing stays readable. */
export function ItemCalendarSheet(props: ItemCalendarSheetProps): ReactElement | null {
  const { t } = useTranslation('calendar');
  return <Suspense fallback={<Spinner label={t('calendar_loading')} />}><Host {...props} /></Suspense>;
}
